export function TextField({ label, value, onChange, placeholder, testid, type = "text" }) {
    return (
        <div>
            {label && <label className="tracked text-coffee/60 text-[10px] block mb-3">{label}</label>}
            <input
                type={type}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                data-testid={testid}
                className="w-full bg-transparent border-b border-coffee/30 focus:border-coffee py-3 text-coffee font-body outline-none"
            />
        </div>
    );
}

export function TextArea({ label, value, onChange, rows = 4, testid, placeholder }) {
    return (
        <div>
            {label && <label className="tracked text-coffee/60 text-[10px] block mb-3">{label}</label>}
            <textarea
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                rows={rows}
                placeholder={placeholder}
                data-testid={testid}
                className="w-full bg-transparent border border-coffee/20 focus:border-coffee p-3 text-coffee font-body outline-none resize-none"
            />
        </div>
    );
}

export function SaveBar({ onSave, saving, label = "Save Changes" }) {
    return (
        <div className="sticky bottom-0 left-0 right-0 -mx-6 md:-mx-10 px-6 md:px-10 py-4 bg-cream-light/95 backdrop-blur-md border-t border-coffee/15 flex justify-end z-20">
            <button
                onClick={onSave}
                disabled={saving}
                className="btn-pill btn-pill-coffee disabled:opacity-50"
                data-testid="save-bar-button"
            >
                {saving ? "Saving…" : label}
            </button>
        </div>
    );
}

export function SectionCard({ title, description, children }) {
    return (
        <section className="bg-white border border-coffee/10 p-6 md:p-8 mb-6">
            <div className="mb-6">
                <h3 className="font-editorial font-bold text-coffee text-2xl">{title}</h3>
                {description && <p className="text-coffee/60 text-sm mt-1">{description}</p>}
            </div>
            <div className="space-y-6">{children}</div>
        </section>
    );
}

export function PageHeader({ title, subtitle }) {
    return (
        <div className="mb-10">
            <div className="tracked text-coffee/50 text-[10px] mb-3">{subtitle}</div>
            <h1 className="font-editorial font-bold text-coffee text-3xl md:text-4xl">{title}</h1>
        </div>
    );
}
